module.exports = __webpack_public_path__ + "static/images/product_table.5ab14a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product_table.png
// module id = Dx4d
// module chunks = 8